import { UzButton } from '@utazzo/ui';
import { BookOpen } from 'lucide-react';
import React from 'react';

import { useDownloadOperatorGuide } from '../use-imports';

/**
 * Sibling of `SampleTemplateButton`. Calls the runtime guide endpoint
 * `GET /imports/:moduleKey/guide`, decodes the base64 Markdown payload,
 * and triggers a browser download of `<moduleKey>-import-guide.md` so
 * the operator has the field reference + cross-sheet rules + tips
 * sitting next to the spreadsheet they're filling in.
 */
export const OperatorGuideButton = ({
  moduleKey,
  label = 'Download guide',
}: {
  moduleKey: string;
  label?: string;
}): React.JSX.Element => {
  const download = useDownloadOperatorGuide();
  return (
    <UzButton
      variant="ghost"
      size="sm"
      loading={download.isPending}
      onClick={() => download.mutate(moduleKey)}
    >
      <BookOpen className="mr-1.5 h-4 w-4" />
      {label}
    </UzButton>
  );
};
